export default __webpack_public_path__ + "152165f74f11da6e7582a2b935b7d885.svg";